<template>
    <modal
        id="employee-termination-modal"
        :scrollable="false"
        v-model="showModal"
        @submit="submit"
        :title="$t('terminate_date')"
        :loading="loading"
        :preloader="preloader">

        <form
            ref="form"
            @submit.prevent="submitData">

            <app-form-group
                type="date"
                :label="$t('terminate_date')"
                :placeholder="$placeholder('terminate_date')"
                v-model="formData.terminate_date"
                :required="true"
                :max-date="maxDate"
                :error-message="$errorMessage(errors, 'terminate_date')"
            />

            <app-form-group
                type="textarea"
                :label="$t('reason')"
                v-model="formData.description"
                :text-area-rows="4"
                :required="true"
                :error-message="$errorMessage(errors, 'description')"
                :placeholder="$t('enter_employee_termination_reason')"
            />
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {axiosPatch} from "../../../../common/Helper/AxiosHelper";
import {EMPLOYEES} from "../../../Config/ApiUrl";
import {formatDateForServer, timezoneDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    name  : "EmployeeTerminationModal",
    mixins: [ModalMixin, FormHelperMixins],
    props : {
        id: {}
    },
    data() {
        return {
            maxDate : timezoneDate(),
            formData: {
                terminate_date: null,
                description: null,
            }
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.errors = {};

            const payload = {
                ...this.formData,
                terminate_date: formatDateForServer(this.formData.terminate_date)
            };

            axiosPatch(`${EMPLOYEES}/${this.id}/terminate`, payload).then(({data}) => {
                $('#employee-termination-modal').modal('hide');
                this.toastAndReload(data.message, 'employee-table');
            }).catch(({response}) => {
                this.errors = response?.data?.errors || {};

                if (!Object.keys(this.errors).length) {
                    this.$toastr.e('', response?.data?.message || 'Error');
                }
            }).finally(() => {
                this.loading = false;
                // setTimeout(() => {
                //     this.$hub.$emit(`open-termination-reason-modal`)
                // })
            });
        },
    }
}
</script>